<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogMsg.dialogCase"
    width="30%"
    :modal-append-to-body="false"
    :before-close="addCaseBack"
  >
    <el-row :gutter="20">
      <el-col :span="18">
        <h4>案列</h4>
        <el-autocomplete
          v-model="selectCase"
          :fetch-suggestions="querySearchAsync"
          @select="handleSelect"
          placeholder="选择案例"
          clearable
          :popper-append-to-body="false"
        >
        </el-autocomplete>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="addCaseBack">取 消</el-button>
      <el-button
        type="primary"
        v-if="dialogMsg.kind != 'update'"
        @click="addCaseOK"
        >添 加</el-button
      >
      <el-button
        type="primary"
        v-if="dialogMsg.kind == 'update'"
        @click="addCaseOK"
        >修 改</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { getPractices } from "../../bestPractice/bestPracticeList.gql";
export default {
  props: { dialogMsg: Object, dialogItem: Object },
  data() {
    return {
      addMsg: {},
      scholarData: [],
      selectCase: "",
    };
  },
  watch: {
    dialogItem(val, oldVal) {
      this.addMsg = JSON.parse(JSON.stringify(val));
      this.selectCase = val.name;
    },
  },
  methods: {
    handleSelect(item) {
      console.log(item);
      this.addMsg.name = item.title;
      this.addMsg.organizer = item.id;
      this.addMsg.image = item.coverImage;
      if (item.author != null) {
        if (item.author.name != null) {
          this.addMsg.author = item.author.name;
        } else {
          this.addMsg.author = item.author.englishName;
        }
      }
      console.log(this.addMsg);
    },
    querySearchAsync(queryString, callback) {
      this.$global
        .GraphqlQuery(this, getPractices, {
          status: 1,
          take: 0,
          order: "+title",
          title: this.selectCase,
        })
        .then((res) => {
          for (let i of res.data) {
            i.value = i.title;
          }
          this.caseData = res.data;
          callback(this.caseData);
        });
    },
    handleClose() {
      this.$emit("addCaseBack", false);
    },
    addCaseBack() {
      this.$emit("addCaseBack", false);
      this.addMsg = {};
    },
    addCaseOK() {
      this.$emit("addCaseOK", this.addMsg);
      console.log(this.addMsg);
      this.addMsg = {};
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-popper {
  width: 300px !important;
}
.el-row {
  display: flex;
  justify-content: center;
  .el-col-18 {
    display: flex;
    h4 {
      width: 40px;
      align-self: center;
      font-size: 16px;
      color: $keywords;
      margin-right: 40px;
    }
  }
}
.el-dialog__footer {
  padding: 10px 25% 20px;
  .dialog-footer {
    height: 28px;
    display: flex;
    justify-content: center;
    .el-button--default:hover {
      background: $base-color;
      color: $blueBtna;
    }
    .el-button--default {
      border-radius: 100px;
      border: 1px solid $schoolTagBorder;
      padding: 4px 24px;
      span {
        font-size: 12px;
        color: $schoolTagColor;
      }
    }
    .el-button--primary {
      border-radius: 100px;
      background: $pageViewSmall;
      border: 1px solid $pageViewSmall;
      padding: 4px 24px;
      span {
        font-size: 12px;
        color: $base-color;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/exploration/components/DialogCase.vue